import React, { useContext, useCallback, useRef, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import "../assets/css/callFlow.css";
import ActionDropdown from "./common/ActionDropdown";
import { useCallFlow } from "../hooks/useCallFlow";
import { useVoiceIntegId } from "../utils/VoiceUtils";
import { AppContext } from "../../context/AppContext";
import HTable from "../../components/custom/table/HTable";
import { EmptyListView, formatDate } from "../../pages/utils/CommonVessels";
import { checkUserHasModuleAccess } from "../../pages/utils/commonUtils";
import { useRolesContext } from "../../context/RolesContext";

const CallFlow = () => {
  const navigate = useNavigate();
  const [rolesProperties] = useRolesContext();
  const location = useLocation();
  const [appProperties] = useContext(AppContext);
  const { getCallFlowList } = useCallFlow();
  const voiceIntegId = useVoiceIntegId(appProperties);
  const callFlowTableRef = useRef(null);

  const callFlowRequest = useCallback(
    async (params) => {
      if (!voiceIntegId) {
        return {
          data: [],
          success: false,
          total: 0,
        };
      }

      try {
        const callFlowResponseData = await getCallFlowList(voiceIntegId);
        return {
          data: callFlowResponseData || [],
          success: true,
          total: callFlowResponseData?.length || 0,
        };
      } catch (error) {
        console.error("Error fetching call flow data:", error);
        return {
          data: [],
          success: false,
          total: 0,
        };
      }
    },
    [getCallFlowList, voiceIntegId]
  );

  useEffect(() => {
    if (voiceIntegId && callFlowTableRef?.current) {
      callFlowTableRef?.current?.reload?.();
    }
  }, [voiceIntegId]);

  const handleEditClick = (callFlowId, phoneNumber) => {
    try {
      const editCallFlowEndpoint = `/voice/callFlow/edit/${callFlowId}/phoneNumber/${encodeURIComponent(phoneNumber)}`;
      navigate(editCallFlowEndpoint + location?.search);
    } catch (error) {
      console.log("Error fetching callflowdata", error);
    }
  };

  const callFlowTableColumns = [
    {
      title: "Phone Number",
      dataIndex: "phoneNumber",
      key: "phoneNumber",
    },
    {
      title: "Name",
      dataIndex: "callFlowName",
      key: "callFlowName",
    },
    {
      title: "Created Time",
      dataIndex: "createdTime",
      align: "left",
      key: "createdTime",
      render: (timestamp) => (timestamp ? formatDate(timestamp) : "-"),
    },
    checkUserHasModuleAccess(rolesProperties?.currentRoleDetails, "channels") && {
      title: "",
      key: "actions",
      align: "right",
      render: (_, record) => (
        <div onClick={(e) => e.stopPropagation()}>
          <ActionDropdown
            placement="bottomLeft"
            onEdit={() => {
              handleEditClick(record?.callFlowId, record?.phoneNumber);
            }}
          />
        </div>
      ),
    },
  ];

  return (
    <div className="p-3">
      <HTable
        tableRef={callFlowTableRef}
        ui={{
          columns: callFlowTableColumns,
          hidePagination: true,
          rowKey: "callFlowId",
        }}
        data={{ request: callFlowRequest }}
        locale={{
            emptyText: (
              <EmptyListView
                tagLineOne={<div> No Call Flow Record</div>}
                icon={`call-action-icons emptyCallFlowIcon display-inline-block`}
                tagHeight={"50vh"}
                tagLineTwo={`Your recent records will appear here`}
              />
            ),
          }}
        onRow={(record) => {
          return {
            onClick: () => {
              // handleEditClick(record.callFlowId);
            },
          };
        }}
      />
    </div>
  );
};

export default CallFlow;
